/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default function Grid({
  className = '',
  children,
  gap,
  columns = 0,
  columnsMobile = 1,
  columnsTablet = 2,
  columnsDesktop = 2,
  tabletBreakpoint = '600px',
  desktopBreakpoint = '1024px',
}) {
  const gridStyles = css`
    display: grid;
    gap: ${gap};

    grid-template-columns: repeat(${columnsMobile || columns}, minmax(0, 1fr));

    @media (min-width: ${tabletBreakpoint}) {
      grid-template-columns: repeat(${columnsTablet || columns}, minmax(0, 1fr));
    }

    @media (min-width: ${desktopBreakpoint}) {
      grid-template-columns: repeat(${columnsDesktop || columns}, minmax(0, 1fr));
    }
  `;

  return (
    <div className={`${className}`} css={gridStyles}>
      {children}
    </div>
  );
}
